export function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

/** Format API lastModified (ISO string) for list display; returns '' if invalid. */
export function formatLastModified(iso) {
  if (!iso || typeof iso !== 'string' || iso.startsWith('http')) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function formatFileMeta(item) {
  const parts = [];
  if (item?.size != null) parts.push(formatBytes(item.size));
  const modified = formatLastModified(item?.lastModified);
  if (modified) parts.push(modified);
  const updatedBy = String(item?.lastUpdatedBy || '').trim();
  if (updatedBy) parts.push(updatedBy);
  return parts.join(' · ');
}
let bucketUrlMap = {}; // fill from /storage/config or Vuex

export function setBucketUrlConfig(map) {
  bucketUrlMap = map;
}

// this helper function is used to target be API that parses image preview on UI.
const IMAGE_EXT = /\.(jpe?g|png|gif|svg|webp|bmp|ico|avif|heic|heif|jfif)$/i;
const VIDEO_EXT = /\.(mp4|webm|ogv|mov|m4v|mkv|avi|wmv)$/i;

export function isImagePath(path) {
  return IMAGE_EXT.test(String(path || ''));
}

export function isVideoPath(path) {
  return VIDEO_EXT.test(String(path || ''));
}

export function imageUrl(bucket, path, imageParse = false) {
  // path already like "/translations/xxx.png" in your code
  const publicBase = bucketUrlMap[bucket]; // undefined if not configured
  if (publicBase && !imageParse) {
    // ensure slashes: publicBase may already end with '/', path begins with '/'
    return `${publicBase.replace(/\/$/, '')}${path}`;
  }
  // fallback: old behaviour — route through backend
  const baseUrl = process.env.VUE_APP_BACKEND_URL;
  return `${baseUrl}/image/${bucket}${path}`;
}

